export const CATEGORIES = [
  {
    id: 'all',
    text: 'image.gallery-all-photos',
    count: 0,
  },
  {
    id: 'room',
    text: 'image.gallery-rooms',
    count: 0,
  },
  {
    id: 'exterior',
    text: 'image.gallery-exterior',
    count: 0,
  },
  {
    id: 'common',
    text: 'image.gallery-common-areas',
    count: 0,
  },
  {
    id: 'pool',
    text: 'image.gallery-pool',
    count: 0,
  },
  {
    id: 'dining',
    text: 'image.gallery-dining',
    count: 0,
  },
  {
    id: 'facility',
    text: 'image.gallery-facilities',
    count: 0,
  },
  {
    id: 'nearby',
    text: 'image.gallery-what-nearby',
    count: 0,
  },
]
